// ============================================
// API Client Configuration
// ============================================

import { createConAIApi, PersistentTokenStorage } from '@conai/api-client';
import { env } from './env';
import { useAuthStore } from '../stores/auth.store';
import { useAdminLanguageStore } from '../stores/language.store';

// Create token storage instance (supports remember me switching)
const tokenStorage = new PersistentTokenStorage('conai_admin');

// Create the API client with configuration
export const api = createConAIApi({
  baseURL: env.apiBaseUrl,
  timeout: env.apiTimeout,
  tokenStorage,
  onAuthError: () => {
    // Clear storage and redirect to login on refresh failure
    tokenStorage.clearTokens();
    useAuthStore.getState().logout();
  },
  getLanguage: () => useAdminLanguageStore.getState().language,
});

// Export for direct access when needed
export { tokenStorage };

// Re-export services for convenience
export const {
  auth: authService,
  users: usersService,
  stores: storesService,
  categories: categoriesService,
  products: productsService,
  inventory: inventoryService,
  stockImports: stockImportsService,
  orders: ordersService,
  payments: paymentsService,
  customers: customersService,
  loyalty: loyaltyService,
  accessControl: accessControlService,
  atWork: atWorkService,
  promotions: promotionsService,
  reports: reportsService,
} = api;
